import moment from 'moment'

import 'moment/locale/ar'
import 'moment/locale/fr'

moment.locale('en')

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
